import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, isRef as _isRef, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3a3cccc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bar" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "名前", -1))
const _hoisted_5 = { class: "name-after" }
const _hoisted_6 = ["min", "max"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "comment" }, "※選択したい日付が選べない時は、システム管理者に連絡すると解決する可能性があります", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "業務", -1))
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "board-buttons -under" }
const _hoisted_11 = ["disabled"]

import { computed, watch, ref } from 'vue';
import { RepunchCtrl, hourOpts, minuteOpts, isValidDate, isValidCategory } from '@/utility/RepunchDialog';
import SelectBoxNum from '@/components/SelectBoxNum.vue';
import { toDateKey } from '@/utility/date';

//  親との通信

export default /*#__PURE__*/_defineComponent({
  __name: 'RepunchDialog',
  props: {
    modelValue: null,
    punchTitles: null,
    nameAfter: null,
    inOut: null,
    deadline: null
  },
  emits: ["update:modelValue", "ok"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: unknown): void;
  (e: 'ok'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: RepunchCtrl;
  punchTitles: Record<number, string>;
  nameAfter: string;
  inOut: string[];
  deadline: Date | undefined;
}



const model = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
});

const today = computed(() => toDateKey(new Date()));
const deadline = computed(() => (props.deadline === undefined ? undefined : toDateKey(props.deadline)));



const isIn = computed(() => model.value.punchType === 4);
const inOut = computed(() => props.inOut[model.value.punchType === 4 ? 0 : 1]);

const modelCategory = computed({
  get: () => model.value.sCategory as number,
  set: value => {
    if (model.value.sCategory) model.value.sCategory = value as number;
  },
});

const fade = ref(0);
watch(
  () => model.value.disp,
  () => {
    const disp = model.value.disp ? 0 : 1;
    fade.value = disp;
    setTimeout(() => {
      fade.value = disp ^ 1;
    }, 50);
  }
);

const hourList = computed(() => hourOpts());
const minutesList = computed(() => minuteOpts());

async function onOk() {
  emit('ok');
  model.value.disp = false;
}

return (_ctx: any,_cache: any) => {
  return (_unref(model).disp)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "s-modal",
        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_unref(model).disp = false), ["self"]))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-frame tablet", ['off', 'on'][fade.value]])
        }, [
          _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(inOut)) + "を登録する", 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("ul", null, [
                _hoisted_4,
                _createElementVNode("dd", null, [
                  _createTextVNode(_toDisplayString(_unref(model).name) + " ", 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(props.nameAfter), 1)
                ]),
                _createElementVNode("dt", null, _toDisplayString(props.punchTitles[_unref(model).punchType]) + "日", 1),
                _createElementVNode("dd", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).dateText) = $event)),
                    min: _unref(deadline),
                    max: _unref(today)
                  }, null, 8, _hoisted_6), [
                    [_vModelText, _unref(model).dateText]
                  ]),
                  _hoisted_7
                ]),
                (_unref(isIn) && _unref(model).categoryOpts)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_8,
                      _createVNode(SelectBoxNum, {
                        modelValue: _unref(modelCategory),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(modelCategory) ? (modelCategory).value = $event : null)),
                        list: _unref(model).categoryOpts
                      }, null, 8, ["modelValue", "list"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(SelectBoxNum, {
                  modelValue: _unref(model).hour,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).hour) = $event)),
                  list: _unref(hourList)
                }, null, 8, ["modelValue", "list"]),
                _createTextVNode(" : "),
                _createVNode(SelectBoxNum, {
                  modelValue: _unref(model).minute,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).minute) = $event)),
                  list: _unref(minutesList)
                }, null, 8, ["modelValue", "list"])
              ])
            ]),
            _createElementVNode("ul", _hoisted_10, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "modal-close btn-small",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(model).disp = false))
                }, "キャンセル")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "modal-ok btn-small",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (onOk())),
                  disabled: !_unref(isValidDate)(_unref(model)) || !_unref(isValidCategory)(_unref(model))
                }, "登録", 8, _hoisted_11)
              ])
            ])
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})